<template>
  <div
    v-if="meta.header !== false"
    class="TheHeader"
  >
    <div class="leftColumn">
      <div
        v-if="meta.headerLeft === 'CANCEL_ORDER'"
        class="HeaderOrderCancel"
      >
        <font-awesome-icon
          @click="onClickCancelOrder"
          :icon="['fal', 'times']"
          size="2x"
        />
        <span class="u-ml10">
          注文の作成をキャンセル
        </span>
      </div>
      <img
        v-else-if="isTrialMode"
        src="@/assets/logo2_trial.png"
        alt="ロゴ"
        class="HeaderLogo"
        style="min-height: 60px;"
      />
      <img
        v-else
        src="@/assets/logo2.png"
        alt="ロゴ"
        class="HeaderLogo"
      />
    </div>

    <div class="centerColumn">
      <h1 class="title">
        {{ title }}
      </h1>
    </div>

    <div
      class="rightColumn"
      v-if="
        currentUser &&
        currentUser.sub &&
        this.$router.history.current.path !== '/sign-in'
      "
    >
      <div
        v-if="meta.headerLeft !== 'CANCEL_ORDER'"
        class="RightColumn-Inner"
      >
        <!-- 通知 > ベルアイコンの要素 -->
        <div v-if="currentUser.role !== 'ADMIN'">
          <div
            v-if="currentUser.sub"
            class="notification-container"
          >
            <font-awesome-icon
              @click="onClickBell"
              :icon="['fal', 'bell']"
              size="2x"
            />
            <span
              @click="onClickBell"
              v-if="currentUser.sub && notiList.includes(false)"
              class="badge1"
              data-badge
            />
          </div>
        </div>

        <!-- ユーザドロップダウン＆メニュー -->
        <el-dropdown
          class="userDropdown"
          trigger="click"
          :hide-on-click="true"
          placement="bottom-end"
          @visible-change="onClickUserDropdown"
          @command="onClickUserDropdownMenu"
        >
          <el-button type="text">
            {{ currentUser.name || currentUser.email }}
            <i
              class="el-icon-arrow-down el-icon--right"
              :class="{
                'fa-rotate-180': isShowUserMenu,
              }"
            />
          </el-button>

          <!--  -->
          <el-dropdown-menu slot="dropdown">
            <!-- 原稿の裏表（左右）を入れ替える -->
            <!-- hide-on-click で閉じないように <el-dropdown-item> ではなく <li> を利用する -->
            <li
              class="el-dropdown-menu__item"
              @click="onClickUserDropdownMenu('FLIP_LAYOUT')"
            >
              <div class="reversedLayoutSwitchCover" />
              <div class="flex gaps">
                <div class="box grow">
                  原稿の裏表入れ替え
                </div>
                <div class="box">
                  <el-switch
                    v-model="localIsReversedLayout"
                    active-color="#409EFF"
                    inactive-color="#C0C4CC"
                  />
                </div>
              </div>
            </li>

            <!-- お気に入り異体字管理 -->
            <el-dropdown-item command="MANAGE_FAVORITE_VARIANT_CHARACTERS">
              お気に入り異体字管理
            </el-dropdown-item>

            <!-- ログアウト -->
            <el-dropdown-item command="LOGOUT">
              ログアウト
            </el-dropdown-item>

            <!-- バージョン情報 -->
            <el-dropdown-item
              disabled
              divided
              command="VERSION"
            >
              <small v-if="!isProduction">
                バージョン: {{ version }} ({{ mode }})
              </small>
              <small v-else>
                バージョン: {{ version }}
              </small>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 通知メッセージ一覧 -->
        <div>
          <div
            v-if="clickBell"
            class="notiTxt multiNotiTxt-pad"
          >
            <!-- 閉じるボタン -->
            <el-tag
              closable
              :disable-transitions="false"
              @close="closeNotification()"
            />

            <!-- ボーダー -->
            <hr class="noti-line" />

            <!-- 通知メッセージ群 -->
            <div class="noti-message">
              <div v-for="(val, index) of notiData" :key="index">
                <hr class="noti-line" />
                <a
                  @click="notiClick(val)"
                  class="a-pointer"
                >
                  <!--  -->
                  <el-badge
                    class="badgeStyNone"
                    :class="{
                      bodgeSty: !val.isRead || (oneNoti && oneNoti.isRead === false),
                    }"
                  >
                    ●
                  </el-badge>
                  <div class="noti-body">
                    <strong class="noti-title" mr-4>{{ val.title }}</strong>
                    <p
                      v-if="val.body.length > 50"
                      class="noti-text"
                    >
                      {{ val.body.substring(0, 50) }}...
                    </p>
                    <p
                      v-else
                      class="noti-text"
                    >
                      {{ val.body }}...
                    </p>
                  </div>
                </a>
              </div>
              <hr class="noti-line" />
            </div>
          </div>

          <!-- 通知メッセージ詳細 -->
          <div class="oneNotiTxt">
            <div
              v-if="detailNoti"
              class="notiTxt oneNotiTxt-pad"
            >
              <!-- 戻るボタン -->
              <div
                class="left-arrow"
                @click="goToNotificationList()"
              >
                <font-awesome-icon
                  :icon="['fal', 'angle-left']"
                />
              </div>

              <!-- 閉じる -->
              <el-tag
                closable
                :disable-transitions="false"
                @close="closeNotification()"
              />

              <!-- 通知メッセージ -->
              <div
                v-if="oneNoti"
                class="oneNoti-body"
              >
                <strong class="noti-title">
                  {{ oneNoti.title }}
                </strong>
                <p class="noti-text">
                  {{ oneNoti.body }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from "vuex";
import Auth from "@/services/auth.service";
import NotificationUsecase from "@/usecases/notification.usecase";

const authService = new Auth();

export default {
  components: {},
  data () {
    return {
      notificationUsecase: new NotificationUsecase(),
      notiData: [],
      clickBell: false,
      detailNoti: false,
      oneNoti: {},
      notiList: [],
      emitData: [],
      version: process.env.VUE_APP_VERSION,
      mode: process.env.VUE_APP_MODE,
      commitHash: process.env.COMMIT_HASH,
      branch: process.env.BRANCH,
      isShowUserMenu: false,
      test: false,
    };
  },
  watch: {
    notiList: async function () {},
  },
  async created () {
    if (this.currentUser && this.currentUser.role) {
      try {
        this.notiData = await this.notificationUsecase.getNotifications();
      } catch (err) {
        // 認証が失敗しているのでサインイン画面に遷移
        if (err === "No current user") {
          const { $router } = this;
          $router.push("/sign-in");
        }
        return;
      }
      const subscriber = await this.notificationUsecase.getAddedNotificationSubscriber();
      subscriber.subscribe({
        next: data => {
          const addedNotification = data.value.data.addedNotification;
          // Subscriptionから取得すると既読判定処理が行われないため、isReadがnullで返ってくる
          // 新規に追加された通知なので、未読とする
          addedNotification.isRead = false;
          // 最新の通知なので、先頭に追加する
          this.notiData.unshift(addedNotification);
        },
      });
      for (let i = 0; i <= this.notiData.length; i++) {
        if (this.notiData[i]) {
          this.notiList.push(this.notiData[i].isRead);
        }
      }
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      isReversedLayout: "config/getIsReversedLayout",
    }),

    localIsReversedLayout: {
      get () {
        return this.isReversedLayout;
      },
      set (value) {
        this.toggleIsReversedLayout();
      },
    },

    currentUser () {
      return this.$store.state.user;
    },

    isProduction: () => {
      return process.env.NODE_ENV === "production";
    },

    isTrialMode: () => {
      return process.env.VUE_APP_MODE === "trial";
    },

    title () {
      return this.$route.meta.title;
    },

    meta () {
      return this.$route.meta;
    },
  },
  methods: {
    ...mapActions({
      toggleIsReversedLayout: "config/toggleIsReversedLayout",
    }),

    /**
     * [onClickUserDropdown description]
     * @param   {[type]}  $event  [$event description]
     */
    onClickUserDropdown ($event) {
      this.isShowUserMenu = $event;

      if ($event) {
        this.onOpenUserDropdownMenu();
      }
    },

    /**
     * [onClickUserDropdownMenu description]
     * @param   {[type]}  $event  [$event description]
     * @return  {[type]}          [return description]
     */
    onClickUserDropdownMenu ($event) {
      // 原稿の裏表（左右）を入れ替える
      if ($event === "FLIP_LAYOUT") {
        this.localIsReversedLayout = !this.localIsReversedLayout;
        return;
      }

      // お気に入り異体字管理
      if ($event === "MANAGE_FAVORITE_VARIANT_CHARACTERS") {
        this.$router.push("/manage-favorite-variant-characters");
        return;
      }

      // ログアウトする
      if ($event === "LOGOUT") {
        this.onClickLogout();
        return;
      }

      console.error("No such event", $event);
    },

    /**
     * [onOpenUserDropdownMenu description]
     */
    onOpenUserDropdownMenu () {
      const { isProduction } = this;

      if (!isProduction) {
        const { commitHash, branch } = this;
        const branchLink = `https://github.com/TheDesignium/nanokos/tree/${branch}`;
        const commitLink = `https://github.com/TheDesignium/nanokos/commit/${commitHash}`;
        console.log("%cbranch: %s\n%o", "font-weight: bold", branch, branchLink);
        console.log("%ccommit: %s\n%o", "font-weight: bold", commitHash, commitLink);
      }
    },

    async onClickLogout () {
      const { commit } = this.$store;
      const res = await signOut();
      if (res) {
        localStorage.clear();
        const { $router } = this;
        commit("user/init");
        $router.push("/sign-in");
        return;
      }
      alert("サインアウトに失敗しました。");
    },
    onClickBell () {
      if (this.notiData.length > 0) {
        this.clickBell = true;
      }
    },
    goToNotificationList () {
      this.detailNoti = false;
      this.clickBell = true;
    },
    async notiClick (notification) {
      this.clickBell = false;
      this.detailNoti = true;
      notification.isRead = true;
      this.emitData = [];
      this.notiList = [];
      const notificationId = notification.id;
      const param = { notificationId };
      this.oneNoti = await this.notificationUsecase
        .readNotification(param)
        .then(notification => {
          return notification.data.notificationRead;
        });
      const notiFlag = await this.notificationUsecase.getNotifications();
      for (let i = 0; i <= notiFlag.length; i++) {
        if (notiFlag[i]) {
          this.emitData.push(notiFlag[i].isRead);
        }
      }
      this.notiList = this.emitData;
    },
    closeNotification () {
      this.clickBell = false;
      this.detailNoti = false;
    },
    onClickCancelOrder () {
      const { $router } = this;
      $router.push("/home");
    },
  },
};

/**
 * sign in with email and password
 * @async
 * @returns {Promise<boolean>} Promise object represents the result of sign out
 */
async function signOut () {
  try {
    await authService.signOut();
    return true;
  } catch (err) {
    return false;
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.TheHeader {
  display: flex;
  border-bottom: solid 1px $--border-color-lighter; // #e6e6e6;
  height: 62px;
}

.HeaderLogo {
  max-width: 100%;
  height: 25px;
  margin-left: 18px;
  transform: translateY(5px);
  margin-bottom: 13px;
}

.HeaderOrderCancel {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.leftColumn,
.centerColumn,
.rightColumn {
  display: flex;
  flex: 1;
  align-items: center;
}

.centerColumn {
  justify-content: center;
}

.rightColumn {
  justify-content: flex-end;
}

.RightColumn-Inner {
  display: flex;
  align-items: center;
}
.notification-container {
  padding: 0 18px;
  cursor: pointer;
}

.title {
  font-size: 20px;
  margin-left: 10px;
}

.navigation {
  display: flex;
  justify-content: flex-end;

  &.el-menu--horizontal {
    border-bottom: none;
  }
}

.el-menu-item.is-disabled {
  border-top: 1px dashed #ededed;
  color: #909399 !important;
  opacity: 1;
}

@media (min-width: 768px) {
  .notiTxt {
    width: 27.5%;
  }
}

@media (max-width: 768px) {
  .notiTxt {
    width: 33%;
  }
}

.notiTxt {
  right: 25px;
  top: 20px;
  border-radius: 9px;
  box-sizing: border-box;
  border: 1px solid $default-border-color-lighter;
  position: fixed;
  background-color: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top 0.4s,
    bottom 0.3s, -webkit-transform 0.3s;
  overflow: hidden;
  z-index: 2000;
}

.noti-message {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.noti-message div:first-child hr {
  display: none;
}

.oneNotiTxt-pad {
  padding: 1rem;
}

.multiNotiTxt-pad {
  padding: 2rem 0rem 1rem 0rem;
}

.notiTxt .el-button {
  line-height: 0;
  padding: 0;
}

.notiTxt .badgeSty {
  color: $blue-base !important;
  margin-left: 1rem;
  margin-top: 1rem;
}

.notiTxt .badgeStyNone {
  color: white;
  margin-left: 1rem;
  margin-top: 1rem;
}

::v-deep .notiTxt .el-tag {
  background-color: white;
  border: none;
  color: black;
  float: right;
  margin-right: -2rem;
}

::v-deep .notiTxt .el-tag .el-icon-close {
  top: -1.5rem;
  color: black;
  right: 3.5rem;
  font-weight: bolder;
  font-size: 17px;
}

::v-deep .oneNotiTxt .el-tag .el-icon-close {
  top: -2.45rem;
  color: black;
  right: 3rem;
  font-weight: bolder;
  font-size: 17px;
}

::v-deep .notiTxt .el-tag .el-icon-close:hover {
  background-color: white;
  color: black;
}

::v-deep .oneNotiTxt .el-tag .el-icon-close:hover {
  background-color: white;
  color: black;
}

::v-deep .oneNotiTxt .el-tag {
  height: 0;
  line-height: 0;
}

::v-deep .oneNotiTxt .el-button--text {
  color: black;
}

.badge1 {
  position: relative;
}

.badge1[data-badge]:after {
  content: attr(data-badge);
  position: absolute;
  top: -10px;
  left: -10px; // -35px;
  font-size: 0.7em;
  background: $blue-base;
  color: white;
  width: 12px; // 18px;
  height: 12px; // 18px;
  text-align: center;
  line-height: 18px;
  border-radius: 50%;
  box-shadow: 0 0 1px $shadow-deep;
}

.noti-body {
  padding: 0rem 1rem 0.17rem 1.5rem;
}

.oneNoti-body {
  padding: 0.7rem 0rem 0rem 0.4rem;
}

.noti-text {
  margin-left: 1.3rem;
  margin-right: 1.3rem;
  font-size: 0.8rem;
}

.noti-title {
  display: -webkit-box;
  width: 80%;
  padding-left: 1.2rem;
  margin-top: -1.35rem;
  font-size: 0.9rem;
}

.a-pointer {
  cursor: pointer;
  display: block;
  margin-top: 0.5rem;
}

.noti-line {
  border: 0.5px solid $--border-color-lighter;
  widows: 100%;
}

.left-arrow {
  padding-left: 1.7rem;
  width: 1rem;
  height: 1rem;
  margin-bottom: 2rem;
  font-weight: bolder;
  font-size: 24px;
  cursor: pointer;
}

// ユーザ設定のドロップダウンメニュー
.userDropdown {
  margin-right: 5px;
  padding: 0 15px;

  .el-button {
    color: $text-lighter;
  }

  .el-icon-arrow-down {
    transform: rotate(360deg);
    transition: all 0.3s ease;

    &.fa-rotate-180 {
      transform: rotate(180deg);
    }
  }
}

// ユーザ設定のドロップダウンメニュー（append <body>）
.el-dropdown-menu {
  top: 46px !important;
  border: none;

  ::v-deep .popper__arrow {
    visibility: hidden;
  }

  ::v-deep .el-dropdown-menu__item--divided {
    border-top: 1px dashed $--border-color-lighter;
  }

  .el-switch {
    transform: scale(0.75);
    transform-origin: 100% 50%;
  }

  ::v-deep .el-dropdown-menu__item {
    position: relative;

    &:first-child {
      margin-bottom: 5px;
    }

    .reversedLayoutSwitchCover {
      position: absolute;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
    }
  }
}
</style>
